import { useEffect, useRef, useState } from "react";

/* Fires once, the first time the element enters the viewport. Used to hold
   every entrance animation back until you actually scroll to it — on a
   12,000px page, anything animating on mount has finished long before the
   reader arrives. */
export function useInView({ rootMargin = "0px 0px -12% 0px",
  threshold = 0.05 } = {}) {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || seen) return;
    if (typeof IntersectionObserver === "undefined") { setSeen(true); return; }
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        setSeen(true);
        io.disconnect();
      }
    }, { rootMargin, threshold });
    io.observe(el);
    return () => io.disconnect();
  }, [seen, rootMargin, threshold]);
  return [ref, seen];
}
